export function getWeb3Error(error: unknown): string {
  const messages: string[] = [];
  const seen = new Set<unknown>();

  function collect(value: unknown) {
    if (!value || seen.has(value)) return;
    if (typeof value === 'string') {
      messages.push(value);
      return;
    }
    if (typeof value !== 'object') return;
    seen.add(value);
    const record = value as Record<string, unknown>;
    for (const key of ['reason', 'shortMessage', 'message']) collect(record[key]);
    for (const key of ['error', 'info', 'data', 'cause']) collect(record[key]);
  }

  if (typeof error === 'object' && error) {
    const value = error as {
      code?: number;
      shortMessage?: string;
      reason?: string;
      message?: string;
      info?: { error?: { message?: string } };
    };
    if (value.code === 4001) return 'Transaction rejected in wallet.';
    collect(error);
    const combined = messages.join(' | ');
    const revertReason = combined.match(/(?:execution reverted|reverted with reason string)[:\s]+["']?([^"'|]+)/i)?.[1]?.trim();
    if (revertReason) return revertReason;
    const useful = messages.find((message) => !/could not coalesce error/i.test(message));
    if (!useful && /could not coalesce error/i.test(combined)) {
      return 'The wallet did not return the contract error. Verify the selected network, sponsor, placement, and User ID, then try again.';
    }
    return useful ?? value.shortMessage ?? value.reason ?? value.info?.error?.message ?? value.message ?? 'Wallet transaction failed.';
  }
  return 'Wallet transaction failed.';
}
